window.DemoInfusionSoftForm = phrase => {
	return {
		val: phrase,
	};
};
